export enum LanguageId {
  SRS = 'srs',
  SPARQL = 'sparql',
}
